import styled from 'styled-components'
import Checkbox from '@material-ui/core/Checkbox'
import MaterialCloseIcon from '@material-ui/icons/Close'
import MaterialDeleteIcon from '@material-ui/icons/Delete'
import MaterialKeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

import { Colors } from '~/styles'


const Container = styled.div`
  padding: 10px 20px;
  background: transparent;
`

const TopFormWrapper = styled.div`
  width: 100%;
  display: grid;
  column-gap: 10px;
  grid-template-columns: repeat(3, 1fr);
`

const DurationInputContainer = styled.div`
  margin-top: -3px;
`

const DurationLabel = styled.label`
  font-size: 11px;
  margin: 7px 0 0 10px;
  transform-origin: top left;
  color: rgba(0, 0, 0, 0.54);
  transform: translate(0, 1.5px) scale(0.75);
`

const DurationInputWrapper = styled.div`
  display: grid;
  column-gap: 5px;
  grid-template-columns: repeat(2, 1fr);
`

const GridContainer = styled.div`
  height: 46rem;
  overflow: auto;
  margin-top: 10px;
  border: 1px solid ${Colors.borderGrey};
`

const HeaderRowGrid = styled.tr`
  & {
    color: white;
    text-align: left;
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: ${Colors.softBlue};
  }
`

const Grid = styled.table`
  width: 100%;
  height: 250px;
  overflow-y: auto;
  table-layout: auto;
  border-collapse: collapse;

  & .equipment-icon {
    cursor: pointer;
  }
`

const TableDataTask = styled.td`
  padding: 8px;
  font-weight: 700;
  color: #4A4A4A;
  font-size: 14px;
`

const TableData = styled.td`
  padding: 8px;
  height: 70px;
  border: ${(p) => p.disableBorder ? 'none' : '1px solid #ddd'};
`

const TableHead = styled.td`
  padding: 8px;
  height: 70px;
  border: 1px solid #ddd;
`

const AddTaskButton = styled.button`
  gap: 2px;
  color: #0082AD;
  border: none;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  background: transparent;
  align-items: center;
  font-weight: 700;
  width: max-content;
`

const BodyRowGrid = styled.tr`
  height: 50px;
`

const BodyRowGridDetail = styled.tr`
  background: ${Colors.borderGrey};
`
const BodyRowGridTask = styled.tr`
  background: #f5f5f5;
  padding: 0;
  border: none;
  outline: none;
`

const ActivityCellWrapper = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 0px !important;
  border-right: 0px !important;
`

const TaskCellWrapper = styled.td`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  height: 70px;
  gap: 4px;
  border-top: 0px !important;
  border-right: 0px !important;
  border: ${(p) => p.isActivityChecklist ? 'none' : '1px solid #ddd'};
  padding-left: ${(p) => p.isActivityChecklist ? '0px' : '45px'} !important;
`

const GreenCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    color: green;
  }

  &.MuiCheckbox-root.Mui-checked {
    color: green;
  }
`

const KeyboardArrowDownIcon = styled(MaterialKeyboardArrowDownIcon)`
  cursor: pointer;
  margin-right: 10px;
  color: ${Colors.grey};
  transform: ${p => p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`

const InnerGrid = styled.table`
  width: 100%;
`

const InnerGridHeader = styled.tr`
  background: #ddd;
  color: ${Colors.black};
`

const TaskGridHeader = styled.tr`
  background: #F5F5F5;
  color: #777777;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
`

const SortWrapper = styled.div`
  padding:  7px 16px 7px 16px;
  border-radius:  32px;
  display:flex;
  cursor:pointer;
  justify-content:space-between;
  border: 1px solid #333333;
`
const InnerGridRow = styled.tr`

`

const DeleteIcon = styled(MaterialDeleteIcon)`
  cursor: ${p => p.disable ? 'not-allowed' : 'pointer'};
  color: ${p => p.disable ? Colors.softGrey : Colors.softRed};
`

const InnerGridActionCell = styled.td`
  display: flex;
  justify-content: space-evenly;
`

const EquipmentIconWrapper = styled.div`
  gap: 2px;
  width: 100%;
  height: 100%;
  display: flex;
  cursor: ${(p) => p.disabled ? 'not-allowed' : 'pointer'};
  align-items: center;
  justify-content: center;
`

const AddTaskCell = styled.div`
  display: grid;
  grid-template-columns: 6fr 1fr;
`

const AddTaskInput = styled.input`
  height: 30px;
  padding: 10px;
  background: ${Colors.white};
  border: 1px solid ${Colors.borderGrey};
`

const AddTaskButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const AddTaskModalContainer = styled.div`
  width: 100%;
  height: 43rem;
  padding: 20px;
`

const AddTaskModalTop = styled.div`
  display: flex;
  justify-content: space-between;
`

const AddTaskModalTopTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
`

const CloseIcon = styled(MaterialCloseIcon)`
  cursor: pointer;

  &.MuiSvgIcon-root {
    font-size: 1.75rem;
  }
`

const AddTaskGridContainer = styled.div`
  margin-top: 15px;
`

const ButtonAddTaskContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const AddItemWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  color: ${Colors.softBlue};
`

const CircularProgressWrapper = styled.div`
  width: 100%;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const EmptyListCell = styled.div`
  text-align: center;
  color: ${Colors.grey};
`

const THead = styled.thead`
  top: 0;
  z-index: 99;
  position: sticky;
`

const ButtonSort = styled.button`
  min-width: 80px;
  color: #333333;
  border-radius: 32px;
  background-color: #ffff;
  border: 1px solid lightblue;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const ModalSort = styled.div`
  position: absolute;
  width: 300px;
  min-height: 100px;
  right: 3%;
  background-color: white;
  margin-top: 10px;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid aliceblue;
  z-index: 1;
`

const SortListWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 5px;
  color: #4a576f;
  align-items: center;
`

const SortTextList = styled.div`
  border: 2px solid #dee0e5;
  width: 200px;
  padding: 5px;
  border-radius: 5px;
  margin-right: 5px;
  font-weight: 400;
`

const ButtonClose = styled.button`
  min-width: 80px;
  color: #A3AAB6;
  border-radius: 5px;
  background-color: #0013340A;
  border: 1px solid lightblue;
  height: 30px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
`

const ButtonFilter = styled.button`
  min-width: 80px;
  color: #FFFF;
  border-radius: 5px;
  background-color: #0A81AD;
  border: 1px solid lightblue;
  height: 30px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-left: 3px;
`
const ColorStatus = styled.span`
  border-radius: 100%;
  width: ${(p) => p.size === 'small' ? '8px' : '12px'};
  height: ${(p) => p.size === 'small' ? '8px' : '12px'};
`

const FirstChildCellArranger = styled.span`
  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
`
const IconWrapper = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
`
const ExclamationIcon = styled.img`
  width: 16px;
  height: 16px;
`

export default {
  Grid,
  THead,
  TableData,
  TableHead,
  Container,
  InnerGrid,
  CloseIcon,
  DeleteIcon,
  BodyRowGrid,
  AddTaskCell,
  SortWrapper,
  AddTaskInput,
  InnerGridRow,
  GridContainer,
  DurationLabel,
  TableDataTask,
  AddTaskButton,
  TaskGridHeader,
  BodyRowGridTask,
  ColorStatus,
  IconWrapper,
  ExclamationIcon,
  FirstChildCellArranger,

  ModalSort,
  ButtonSort,
  ButtonClose,
  SortTextList,
  ButtonFilter,
  SortListWrapper,

  HeaderRowGrid,
  GreenCheckbox,
  EmptyListCell,
  TopFormWrapper,
  AddItemWrapper,
  InnerGridHeader,
  AddTaskModalTop,
  TaskCellWrapper,
  BodyRowGridDetail,
  InnerGridActionCell,
  ActivityCellWrapper,
  AddTaskGridContainer,
  AddTaskModalTopTitle,
  AddTaskButtonWrapper,
  EquipmentIconWrapper,
  DurationInputWrapper,
  AddTaskModalContainer,
  KeyboardArrowDownIcon,
  ButtonAddTaskContainer,
  DurationInputContainer,
  CircularProgressWrapper,
}